import React from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import { LegacyAnalyticsInterface } from '@nerdwallet/calculator-onboarding-modal';
import { InputPercent } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { MORTGAGE } from '../../../../lib/analytics-constants';
import { validationsSelector } from '../../../../lib/selectors';
import { inputsSelector } from '../../../../lib/selectors/mortgage-calculator';
import {
  MortgageInput,
  INPUT_TRACKING_TYPES,
  inputOnChange,
  BedrockInterface,
} from '../../../../lib/utils';
import { debouncedTrackInputEvent } from '../../../../lib/analytics/trackers';
import useAnalytics from '../../../../lib/analytics/use-analytics';

import style from './annual-interest-rate-input.module.less';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const AnnualInterestRateInput: React.FC<MortgageInput> = ({
  inputs,
  dispatch,
  analytics,
  validations,
  label = '',
  tooltip = '',
  fullWidth,
}) => {
  const segmentAbstract = useAnalytics();
  const decimalValue = inputs?.annualInterestRate;
  const percentageValue = !_.isNil(decimalValue)
    ? num.formatPercent(decimalValue)
    : '';
  const errorMessage = validations?.annualInterestRate?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy: LegacyAnalyticsInterface;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'annualInterestRate',
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock: BedrockInterface;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_n',
      };
    }

    // segment analytics
    debouncedTrackInputEvent(
      {
        entityName: 'loan_interest_rate',
        field: 'Interest Rate',
        field_type: 'user_type_input',
        field_value: e.target.value,
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'annualInterestRate',
      calculator: MORTGAGE,
      inputType: 'percentage',
    });
  };

  return (
    <InputPercent
      onChange={onInputChange}
      value={percentageValue}
      decimalScale={3}
      numberOfDigits={3}
      error={error}
      errorMessage={errorMessage}
      label={label}
      tooltip={tooltip}
      className={style['annual-interest-rate']}
      fullWidth={fullWidth}
    />
  );
};

const mapStateToProps = (state) => ({
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
});

export default connect(mapStateToProps)(AnnualInterestRateInput);
